<section class="content-header">
  <div #container class="container-fluid-global">
    <!-- Selected entity / global -->
    @if (globalEntity) {
      <app-home-entity-card
        [entity]="globalEntity"
        [height]="globalCardHeight"
        [global]="true"
      ></app-home-entity-card>
    }

    @if (homeGlobalEntities) {
      <!-- Entity list -->
      <div class="home-entities-list custom-scrollbar">
        <div class="home-entities-list-header">
          <span class="home-entity-row-icon"><i class="fas fa-eye"></i></span>
          <div class="home-entity-select-column">
            <span class="home-entity-row-icon"><i class="fas fa-chart-pie"></i></span>
            <input
              type="checkbox"
              name="entity-visibility"
              class="pointer"
              [(ngModel)]="showAllEntities"
              (change)="updateEntitiesVisibility()"
            />
          </div>
          <span class="home-entity-row-title">{{ "entity" | translate }}</span>
          <span class="home-entity-row-totals">{{ "alarms" | translate }}</span>
          <span class="home-entity-row-totals">{{ "devices" | translate }}</span>
          <span class="home-entity-row-graph">{{ "network" | translate }}</span>
        </div>
        @for (entity of homeGlobalEntities; track entity.id) {
          @if (entity.hasDevices) {
            <app-home-entity-data-row
              [entity]="entity"
              [height]="globalCardHeight"
              (showEntity)="updateTotals(); checkAllEntities()"
            ></app-home-entity-data-row>
          }
        }
      </div>
    }

    <!-- Filters -->
    @if (homeGlobalEntities) {
      <div class="home-entities-filters custom-scrollbar">
        <!-- Search -->
        <div class="home-entities-search">
          <mat-form-field appearance="fill">
            <mat-label>{{ "search" | translate }}</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="searchEntity"
              placeholder="{{ 'search' | translate }}..."
              (keyup)="updateFilters()"
            />
          </mat-form-field>
        </div>
        <!-- Country -->
        @if (countryList?.length > 1) {
          <ng-country-select
            [lang]="countrySelectorLang"
            [includeCountries]="countryList"
            [placeholder]="'country' | translate"
            (countrySelected)="selectedCountry = $event?.alpha2; updateFilters()"
            (inputChanged)="selectedCountry = null; updateFilters($event)"
          ></ng-country-select>
        }
        <!-- Entity ordering -->
        <div class="home-entities-order">
          <app-material-select
            [fullWidth]="true"
            [title]="'order-by' | translate"
            [bindValue]="'id'"
            [bindLabel]="'name'"
            [selected]="'entity'"
            [data]="orderByData"
            (selectedOption)="orderBy = $event.id; updateEntitiesOrder()"
          ></app-material-select>
          <i
            class="fas fa-sort pointer"
            [ngClass]="reverseOrder ? 'sort-up' : 'sort-down'"
            (click)="reverseOrder = !reverseOrder; updateReverseOrder()"
          ></i>
        </div>
        <!-- Alarms -->
        @if (filterAlarmList) {
          <!-- Filter -->
          <app-material-select
            [filter]="true"
            [fullWidth]="true"
            [multiple]="true"
            [clearable]="true"
            [title]="'alarms-filter' | translate"
            [bindValue]="'alarmCode'"
            [bindLabel]="'filter'"
            [avoidFirstPropagation]="true"
            [data]="filterAlarmList"
            (selectedOption)="alarmFilter = $event; updateFilters()"
          ></app-material-select>
          <!-- Most frequent alarms -->
          <div class="home-entities-featured-alarms">
            <span>{{ "featured-alarms" | translate }}</span>
            @for (alarm of mainAlarmList; track alarm.alarmCode) {
              <div>
                <span class="home-entities-featured-alarms-name">
                  {{ alarm.name }} (
                  <span>
                    {{ formatNumber(alarm.total, numberFormat) }}
                  </span>
                  )
                </span>
                <i class="fas fa-info pointer" (click)="alarm.info = !alarm.info"></i>
              </div>
              <div class="home-entities-featured-alarms-desc" [ngClass]="{ hidden: !alarm.info }">
                {{ alarm.desc != "" ? alarm.desc : ("no-details" | translate) }}
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</section>
